const middleware = {}

middleware['ensureUserLoaded'] = require('../middleware/ensureUserLoaded.js')
middleware['ensureUserLoaded'] = middleware['ensureUserLoaded'].default || middleware['ensureUserLoaded']

middleware['requireAdminRole'] = require('../middleware/requireAdminRole.js')
middleware['requireAdminRole'] = middleware['requireAdminRole'].default || middleware['requireAdminRole']

export default middleware
